"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeroUIProvider = void 0;
const react_1 = __importDefault(require("react"));
const react_2 = require("@heroui/react");
function HeroUIProvider({ children }) {
    return react_1.default.createElement(react_2.HeroUIProvider, { locale: "en-GB" }, children);
}
exports.HeroUIProvider = HeroUIProvider;
